const defaultTags = [
	{ type: 'good', icon: 'tag/icv-good' },
	{ type: 'bad', icon: 'tag/icv-bad' },
	{ type: 'tag', icon: 'tag/icv-tag' },
	{ type: 'drill', icon: 'tag/icv-drill' }
]

const basketballTags = [
	{ type: 'FTM', icon: 'tag/basketball/icv-ftm' },
	{ type: 'FGM', icon: 'tag/basketball/icv-fgm' },
	{ type: '3PM', icon: 'tag/basketball/icv-3pm' },
	{ type: 'rebound', icon: 'tag/basketball/icv-rebound' },
	{ type: 'assist', icon: 'tag/basketball/icv-assist' },
	{ type: 'steal', icon: 'tag/basketball/icv-steal' },
	{ type: 'block', icon: 'tag/basketball/icv-block' }
]

const soccerTags = [
	{ type: 'goal', icon: 'tag/soccer/icv-goal' },
	{ type: 'shot', icon: 'tag/soccer/icv-shot' },
	{ type: 'assist', icon: 'tag/soccer/icv-assist' },
	{ type: 'save', icon: 'tag/soccer/icv-save' },
	{ type: 'block', icon: 'tag/soccer/icv-block' },
	{ type: 'duel', icon: 'tag/soccer/icv-duel' },
	{ type: 'free kick', icon: 'tag/soccer/icv-free_kick' },
	{ type: 'corner kick', icon: 'tag/soccer/icv-corner_kick' },
	{ type: 'throw in', icon: 'tag/soccer/icv-throw_in' },
	{ type: 'goal kick', icon: 'tag/soccer/icv-goal_kick' },
	{ type: 'penalty kick', icon: 'tag/soccer/icv-penalty_kick' },
	{ type: 'kickoff', icon: 'tag/soccer/icv-kickoff' },
	{ type: 'foul', icon: 'tag/soccer/icv-foul' }
]

const iceHockeyTags = [
	{ type: 'faceoff', icon: 'tag/ice_hockey/icv-faceoff' },
	{ type: 'breakout', icon: 'tag/ice_hockey/icv-breakout' },
	{ type: 'goal', icon: 'tag/ice_hockey/icv-goal' },
	{ type: 'shot', icon: 'tag/ice_hockey/icv-shot' },
	{ type: 'save', icon: 'tag/ice_hockey/icv-save' },
	{ type: 'block', icon: 'tag/ice_hockey/icv-block' },
	{ type: 'power play', icon: 'tag/ice_hockey/icv-power_play' },
	{ type: 'penalty kill', icon: 'tag/ice_hockey/icv-penalty_kill' },
	{ type: 'check', icon: 'tag/ice_hockey/icv-check' }
]

const volleyballTags = [
	{ type: 'ace', icon: 'tag/volleyball/icv-ace' },
	{ type: 'serve', icon: 'tag/volleyball/icv-serve' },
	{ type: 'dig', icon: 'tag/volleyball/icv-dig' },
	{ type: 'assist', icon: 'tag/volleyball/icv-assist' },
	{ type: 'attack', icon: 'tag/volleyball/icv-attack' },
	{ type: 'kill', icon: 'tag/volleyball/icv-kill' },
	{ type: 'block', icon: 'tag/volleyball/icv-block' },
	{ type: 'error', icon: 'tag/volleyball/icv-error' }
]

const baseballTags = [
	{ type: 'single', icon: 'tag/baseball/icv-single' },
	{ type: 'double', icon: 'tag/baseball/icv-double' },
	{ type: 'triple', icon: 'tag/baseball/icv-triple' },
	{ type: 'home run', icon: 'tag/baseball/icv-home_run' },
	{ type: 'double play', icon: 'tag/baseball/icv-double_play' },
	{ type: 'steal', icon: 'tag/baseball/icv-steal' },
	{ type: 'caught stealing', icon: 'tag/baseball/icv-caught_stealing' },
	{ type: 'hit', icon: 'tag/baseball/icv-hit' },
	{ type: 'error', icon: 'tag/baseball/icv-error' },
	{ type: 'strikeout', icon: 'tag/baseball/icv-strikeout' }
]

const softballTags = [
	{ type: 'single', icon: 'tag/softball/icv-single' },
	{ type: 'double', icon: 'tag/softball/icv-double' },
	{ type: 'triple', icon: 'tag/softball/icv-triple' },
	{ type: 'home run', icon: 'tag/softball/icv-home_run' },
	{ type: 'double play', icon: 'tag/softball/icv-double_play' },
	{ type: 'steal', icon: 'tag/softball/icv-steal' },
	{ type: 'caught stealing', icon: 'tag/softball/icv-caught_stealing' },
	{ type: 'hit', icon: 'tag/softball/icv-hit' },
	{ type: 'error', icon: 'tag/softball/icv-error' },
	{ type: 'strikeout', icon: 'tag/softball/icv-strikeout' }
]

const lacrosseTags = [
	{ type: 'assist', icon: 'tag/lacrosse/icv-assist' },
	{ type: 'block', icon: 'tag/lacrosse/icv-block' },
	{ type: 'clear', icon: 'tag/lacrosse/icv-clear' },
	{ type: 'foul', icon: 'tag/lacrosse/icv-foul' },
	{ type: 'goal', icon: 'tag/lacrosse/icv-goal' },
	{ type: 'ground ball', icon: 'tag/lacrosse/icv-ground_ball' },
	{ type: 'man up', icon: 'tag/lacrosse/icv-man_up' },
	{ type: 'save', icon: 'tag/lacrosse/icv-save' },
	{ type: 'shot', icon: 'tag/lacrosse/icv-shot' },
	{ type: 'turnover', icon: 'tag/lacrosse/icv-turnover' }
]

const lacrosseMenTags = [
	{ type: 'faceoff', icon: 'tag/lacrosse/icv-faceoff' }
]

const lacrosseWomenTags = [
	{ type: 'draw', icon: 'tag/lacrosse/icv-draw' }
]

const fieldhockeyTags = [
	{ type: 'goal', icon: 'tag/icv-tag' },
	{ type: 'shot', icon: 'tag/icv-tag' },
	{ type: 'save', icon: 'tag/icv-tag' },
	{ type: 'block', icon: 'tag/icv-tag' },
	{ type: 'assist', icon: 'tag/icv-tag' },
	{ type: 'free hit', icon: 'tag/icv-tag' },
	{ type: 'short corner', icon: 'tag/icv-tag' },
	{ type: 'long corner', icon: 'tag/icv-tag' },
	{ type: 'penalty hit', icon: 'tag/icv-tag' },
	{ type: 'P1 start', icon: 'tag/icv-tag' },
	{ type: 'P2 start', icon: 'tag/icv-tag' },
	{ type: 'P3 start', icon: 'tag/icv-tag' },
	{ type: 'P4 start', icon: 'tag/icv-tag' },
	{ type: 'OT start', icon: 'tag/icv-tag' }
]

export default {
	default: defaultTags,
	basketball: basketballTags,
	soccer: soccerTags,
	hockey: iceHockeyTags,
	iceHockey: iceHockeyTags,
	volleyball: volleyballTags,
	baseball: baseballTags,
	softball: softballTags,
	'lacrosse-men': lacrosseTags.concat(lacrosseMenTags),
	'lacrosse-women': lacrosseTags.concat(lacrosseWomenTags),
	fieldhockey: fieldhockeyTags
}
